<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Container, Button, Modal, Text, Checkbox } from '@Shelly/shelly-design-system';
	//Helpers
	import { deleteVirtualTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	import type { Device } from 'src/types/Device';

	export let parentDevice: Device;
	export let virtualDevice: Device;
	export let showDeleteModal = false;
	export let showCreateTemplateModal = false;

	let waitForResponse = false;
	let deleteGroup = false;

	const deleteTemplate = async () => {
		waitForResponse = true;
		const res = await deleteVirtualTemplate(virtualDevice, parentDevice, deleteGroup);
		if (res?.isok) {
			showDeleteModal = false;
			showCreateTemplateModal = false;
		}
		onSettingsResponse(res, virtualDevice);
		waitForResponse = false;
	};
</script>

<Modal
	showModal={showDeleteModal}
	on:close={() => (showDeleteModal = false)}
	title={$format('button_delete', { default: 'Delete' })}
	><svelte:fragment slot="content">
		<Container padding="0">
			<Text class="mb-s">
				{$format('vc_template_delete_msg', {
					default: 'Are you sure you want to delete this Virtual Template Device?',
				})}
			</Text>
			<Checkbox bind:checked={deleteGroup} size="l" id="checkbox-delete-group">
				{$format('button_delete_group', {
					default: 'Delete Group',
				})}
			</Checkbox>
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			disabled={waitForResponse}
			on:click={() => (showDeleteModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			loading={waitForResponse}
			disabled={waitForResponse}
			on:click={deleteTemplate}
		>
			{$format('button_delete', { default: 'Delete' })}
		</Button>
	</div>
</Modal>
